import React, { useState } from 'react';
import { Formik, Field, Form, FormikActions, ErrorMessage } from 'formik';
import { required, isEmail } from 'utils/formValidators';
import { Link } from 'react-router-dom';
import TextField from 'components/TextField';
import RecaptchaField from 'components/RecaptchaField';

import Instructions from './components/Instructions';

import { restore as restoreAPI } from 'api/regRequest';

interface IValues {
  email: string;
  recaptcha: string;
}

const LoginPage: React.SFC = () => {
  const [showForm, toggleForm] = useState(true);

  const submit = (values: IValues, { setSubmitting, setStatus, setFieldError }: FormikActions<IValues>) => {
    restoreAPI(values).then((response: any) => {
      if (response.success) {
        toggleForm(false);
      } else {
        setFieldError('email', 'Такого почтового ящика не найдено');
      }
      setSubmitting(false);
    });
  };

  return (
    <React.Fragment>
      {showForm ? (
        <Formik
          initialValues={{
            email: '',
            recaptcha: '',
          }}
          onSubmit={submit}
          // validate={formValidate}
          render={({ errors, touched, isValidating, isSubmitting, handleReset, status }) => (
            <div className="container">
              <div className="entry text-center m-auto">
                <h2 className="entry__title">Восстановление пароля</h2>
                <Form>
                  <div className="form-group text-left">
                    <label htmlFor="input1">Ваш email</label>
                    <Field
                      id="input1"
                      name="email"
                      placeholder="Email"
                      component={TextField}
                      validate={isEmail}
                    />
                    <div style={{ height: '25px', textAlign: 'left' }}>
                      {/* {status && !isSubmitting && <span className="invalid">{status}</span>} */}
                      <span className="invalid"><ErrorMessage name="email" /></span>
                    </div>
                  </div>
                  <Field
                    name="recaptcha"
                    component={RecaptchaField}
                    validate={required}
                  />
                  <div className="form-group mb-0">
                    <button type="submit" disabled={isSubmitting} className="btn">Восстановить</button>
                    <Link to="/auth/login" className="reg__clean">Назад</Link>
                  </div>
                </Form>
              </div>
            </div>
          )}
        />
      ) : (
        <Instructions />
      )}
    </React.Fragment>
  );
};

export default LoginPage;
